var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulkroles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9943 16.6665C10.4706 16.6665 7.46094 17.238 7.46094 19.5222C7.46094 21.8081 10.4514 22.3993 13.9943 22.3993C17.518 22.3993 20.5276 21.8278 20.5276 19.5436C20.5276 17.2577 17.5371 16.6665 13.9943 16.6665Z",
    fill: "#FDB426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9935 14.4875C16.3934 14.4875 18.3166 12.5101 18.3166 10.0426C18.3166 7.57506 16.3934 5.59766 13.9935 5.59766C11.5945 5.59766 9.67041 7.57506 9.67041 10.0426C9.67041 12.5101 11.5945 14.4875 13.9935 14.4875Z",
    fill: "#FDB426"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkroles);
export default __webpack_public_path__ + "static/media/bulkroles.f413ada262f51b28d6f6d13f13319f77.svg";
export { ForwardRef as ReactComponent };